// extracted by mini-css-extract-plugin
export default {"whiteBoxContainer":"AboutUs_whiteBoxContainer__bLg0z","whiteBox":"AboutUs_whiteBox__zO28t","imageContainer":"AboutUs_imageContainer__Ve-pT"};